export default function Header() {
  return (
    <div className="header">
      <h3>Housing, Mobile!</h3>
    </div>
  );
}
